export default __webpack_public_path__ + "static/media/Shot_35.0000.f7122252.png";